import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { isPresent } from 'services/operators';
import { ApplicationConfigService } from 'services/application-config.service';
import { createRequestOption } from 'app/shared/util/request-util';
import { getAcceptanceIdentifier, IAcceptance } from '../models/acceptance.model';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';

export type EntityResponseType = HttpResponse<IAcceptance>;
export type EntityArrayResponseType = HttpResponse<IAcceptance[]>;

@Injectable({ providedIn: 'root' })
export class AcceptanceService implements IBaryTableFetchService<IAcceptance> {
  protected resourceUrl: string;

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('api/acceptances');
  }

  create(entity: IAcceptance): Observable<EntityResponseType> {
    return this.http.post<IAcceptance>(this.resourceUrl, entity, { observe: 'response' });
  }

  update(acceptance: IAcceptance): Observable<EntityResponseType> {
    return this.http.put<IAcceptance>(`${this.resourceUrl}/${getAcceptanceIdentifier(acceptance)}`, acceptance, {
      observe: 'response',
    });
  }

  partialUpdate(acceptance: IAcceptance): Observable<EntityResponseType> {
    return this.http.patch<IAcceptance>(`${this.resourceUrl}/${getAcceptanceIdentifier(acceptance)}`, acceptance, {
      observe: 'response',
    });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IAcceptance>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IAcceptance[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  queryAsCustomer(customerId: number, req?: any): Observable<any> {
    return this.query(req);
  }

  fillDataToShow(entities: IAcceptance[]): Observable<IAcceptance[]> {
    return of(entities);
  }

  addAcceptanceToCollectionIfMissing(acceptanceCollection: IAcceptance[], ...acceptancesToCheck: (IAcceptance | null | undefined)[]): IAcceptance[] {
    const acceptances: IAcceptance[] = acceptancesToCheck.filter(isPresent);
    if (acceptances.length > 0) {
      const acceptanceCollectionIdentifiers = acceptanceCollection.map(acceptanceItem => getAcceptanceIdentifier(acceptanceItem));
      const acceptancesToAdd = acceptances.filter(acceptanceItem => {
        const acceptanceIdentifier = getAcceptanceIdentifier(acceptanceItem);
        if (acceptanceIdentifier == null || acceptanceCollectionIdentifiers.includes(acceptanceIdentifier)) {
          return false;
        }
        acceptanceCollectionIdentifiers.push(acceptanceIdentifier);
        return true;
      });
      return [...acceptancesToAdd, ...acceptanceCollection];
    }
    return acceptanceCollection;
  }
}
